<div class="cashier-search-wrap" #eventListener>
    <div class="input-wrap">
        <div class="searchable-wrap">
            <div class="searchable eventcode-wrap">
                <input id="eventCode" autocomplete="off" class="form-control form-control-sm code-input" type="text" placeholder="Event code" [(ngModel)]="eventCode" (ngModelChange)="eventSearch()" (keyup)="filterFunction($event)" />
                <ul data-prematch *ngIf="!showLiveEvents">
                    <li *ngFor="let event of events" [attr.data-code]="event.code" (click)="selectEvent(event)">{{event.code}} - {{event.eventName}}</li>
                </ul>
                <ul class="" *ngIf="showLiveEvents">
                    <li *ngFor="let liveEvent of liveEvents" [attr.data-code]="liveEvent.code" (click)="selectEvent(liveEvent)">{{liveEvent.code}} - {{liveEvent.eventName}}</li>
                </ul>
            </div>
            <div class="searchable betcode-wrap">
                <input type="text" id="betCode" autocomplete="off" placeholder="Bet Outcome Codes" class="form-control form-control-sm code-input" [(ngModel)]="betOutcomeCode" (ngModelChange)="searchOutcomesByCode()" (keyup)="filterFunction($event)" >
                <ul class="long" *ngIf="filteredOutcomesAndCodeValues.length > 0">
                    <li *ngFor="let outcomeAndCodeValue of filteredOutcomesAndCodeValues" [attr.data-btoid]="outcomeAndCodeValue.betOutcome.id" (click)="addItemToTicket(outcomeAndCodeValue.betOutcome); $event.stopPropagation();">
                        <span class="code">{{outcomeAndCodeValue.codeValue?.code}}</span>
                        <span class="bet-type-name">{{betTypeShowTypes[outcomeAndCodeValue.betOutcome.betTypeId]?.betTypeName}}</span>
                        <span class="outcome-name">{{outcomeAndCodeValue.betOutcome.name}}</span>
                        <span class="sbv">{{outcomeAndCodeValue.betOutcome.sbv}}</span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="checkbox-wrap">
            <input id="searchByExactCodeValue" type="checkbox" [attr.checked]="searchByExactCodeValue" >
            <label [attr.for]="'searchByExactCodeValue'" (click)="changeSearchOption()"> Search by exact Code</label>
        </div>
        
        <!-- <input list="eventBets" id="betCode" *ngIf="!showCodeButtons" class="form-control form-control-sm betCode-input" type="text" placeholder="Bet code" />
        <datalist id="eventBets">
            <option *ngFor="let betOutcome of betOutcomes" [value]="betOutcome.name">
        </datalist> -->
        <div class="buttons-wrap" *ngIf="showCodeButtons">
            <input id="code1" class="form-control form-control-sm code1-input" type="text" placeholder="Code 1" />
            <input id="code2" class="form-control form-control-sm code2-input" type="text" placeholder="Code 2" />
        </div>
        <!-- <button id="searchButton" class="btn primary small icon icon-magnifier" (click)="eventSearch()"></button> -->
        <!-- <button id="searchButton" class="btn primary small icon icon-menu" (click)="eventBetsSearch()"></button> -->
        <!-- <button id="searchButton" class="btn primary small icon icon-magnifier" (click)="showCodeButtons = !showCodeButtons"></button> -->

        <!-- <mat-form-field class="code-input">
            <mat-label>Event code</mat-label>
            <input id="code" matInput>
            <mat-icon matSuffix class="mat-sufix-ico" >arrow_right</mat-icon>
        </mat-form-field>

        <mat-form-field class="betCode-input">
            <mat-label>Bet code</mat-label>
            <input id="betCode" matInput>
            <mat-icon matSuffix class="mat-sufix-ico" >send</mat-icon>
        </mat-form-field> -->

    </div>

    <!-- <mat-form-field>
        <mat-label>State</mat-label>
        <mat-select>
            <input class="form-control form-control-sm code-input" [(ngModel)]="eventCode" (input)="search()">
            <mat-option>None</mat-option>
            <mat-option *ngFor="let event of events" [value]="event.id">{{event.name}}</mat-option>
        </mat-select>
    </mat-form-field> -->
    <!-- <br>
    <select id="select-state" placeholder="Pick a state...">
        <option value="">Select a state...</option>
        <option value="AL">Alabama</option>
        <option value="AK">Alaska</option>
        <option value="AZ">Arizona</option>
        <option value="AR">Arkansas</option>
        <option value="CA">California</option>
        <option value="CO">Colorado</option>
        <option value="CT">Connecticut</option>
        <option value="DE">Delaware</option>
        <option value="DC">District of Columbia</option>
        <option value="FL">Florida</option>
        <option value="GA">Georgia</option>
        <option value="HI">Hawaii</option>
        <option value="ID">Idaho</option>
        <option value="IL">Illinois</option>
        <option value="IN">Indiana</option>
    </select> -->
    <!-- <br>
    <input list="brow">
    <datalist id="brow">
        <option value="Internet Explorer">
        <option value="Firefox">
        <option value="Chrome">
        <option value="Opera">
        <option value="Safari">
    </datalist> -->
</div>
